/** What is safe to put on screen: enough to tell two keys apart, not enough to use. */
export function maskKey(key: string): string {
  const parts = key.split("_");
  const id = parts[1] ?? "";
  return `lrd_${id.slice(0, 4)}…${key.slice(-4)}`;
}
